import axios from 'axios';
import router from '../router/index';
import Qs from 'qs';
import { devDomain, proDomain } from './index';
import { Message } from 'element-ui'; // 消息提示框组件 这个你们可以不用
import { getStorage } from './index';

// 环境的切换
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = devDomain;
    console.log('axios.defaults.baseURL:development');
} else if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = devDomain;
    console.log('axios.defaults.baseURL:debug');
} else if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = proDomain;
    console.log('axios.defaults.baseURL:production');
} else {
    axios.defaults.baseURL = proDomain;
    console.log('axios.defaults.baseURL:else');
}

// 设置请求超时时间
axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;

// 请求拦截
axios.interceptors.request.use(
    (config) => {
        const token = getStorage('token');
        const refreshToken = getStorage('refreshToken');
        if (token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers['token'] = token;
            config.headers['refreshToken'] = refreshToken;
        }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.error(error);
    }
);

// 响应拦截
axios.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        if (response.data.code >= 50000) {
			if(response.data.code == 50004){
				Message({ message: response.data.msg, type: 'error' });
				//router.push('/login');
			}else{
				Message({ message: response.data.msg, type: 'error' });
			}
        }
        // if (response.data.success == false) {
        //     Message({ message: response.data.msg, type: 'error' });
        // }
        return response;
    },
    (error) => {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

// 封装get方法和post方法

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            params: params
        })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    delete params.createUserId;
    delete params.createTime;
    delete params.updateUserId;
    // delete params.updateTime;
    delete params.deleteFlag;
    //console.log({ params });
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: Qs.stringify(params)
        })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

export function postJson(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: params
        })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

/**
 * 上传文件方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function upload(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: params,
            headers: { 'content-Type': 'multipart/form-data' }
        })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    delete params.createUserId;
    delete params.createTime;
    delete params.updateUserId;
    delete params.updateTime;
    return new Promise((resolve, reject) => {
        //axios;
        axios({
            method: 'put',
            url: url,
            data: params,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteFun(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .delete(url, {
                params: params
            })
            .then((res) => {
                resolve(res.data);
                // Message({ message: '请求成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '请求失败', type: 'error' });
            });
    });
}

export function exprotExcel(url, params, btnLoading) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
                responseType: 'blob'
            })
            .then((res) => {
                btnLoading = false;
                if (res.data.type) {
                    // 文件下载
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.ms-excel'
                    });
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', '导出数据.xlsx');
                    link.click();
                    link = null;
                    Message({ message: '导出成功', type: 'success' });
                } else {
                    // 返回json
                    this.$message.warning(res.data.msg);
                }
            })
            .catch((err) => {
                btnLoading = false;
                this.$message.error('导出失败');
            });
    });
}

export function importTemplate(url, btnLoading) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                responseType: 'blob'
            })
            .then((res) => {
                btnLoading = false;
                if (res.data.type) {
                    // 文件下载
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.ms-excel'
                    });
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', '导入模板.xlsx');
                    link.click();
                    link = null;
                    Message({ message: '下载成功', type: 'success' });
                } else {
                    // 返回json
                    this.$message.warning(res.data.msg);
                }
            })
            .catch((err) => {
                btnLoading = false;
                this.$message.error('下载失败');
            });
    });
}

export function importDate(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: params,
            headers: { 'content-Type': 'multipart/form-data' }
        })
            .then((res) => {
                resolve(res.data);
                Message({ message: '导入成功', type: 'success' });
            })
            .catch((err) => {
                reject(err.data);
                Message({ message: '导入失败', type: 'error' });
            });
    });
}
